
import axios from 'axios';
import { LLMMaskResponse } from '../../types/llm';

export const getMaskResults = async (
  text: string,
  top_k: number
) => {
  return await axios
    .post<LLMMaskResponse>(
      `${process.env.REACT_APP_BACKEND_URL}/llm/mask`,
      {
        text: text,
        top_k: top_k ?? 5,
      }
    )
    .then((response) => {
      return response.data;
    });
};
